import * as React from 'react'

/**
 * @description HandUp icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { HandUp } from '@sravni/design-system-icons'
 *
 * <HandUp />
 * ```
 */
export const HandUp = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="HandUp" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.853 16.953v1.667c0 .46.373.833.833.833h5.833c.46 0 .833-.373.833-.833v-1.667a.834.834 0 0 0-.833-.833H5.686a.834.834 0 0 0-.833.833ZM9.853 7.787v-3.75a1.25 1.25 0 0 1 2.5 0v7.083l2.49-1.245a1.31 1.31 0 0 1 1.437 2.164l-4.292 3.68c-.302.258-.687.401-1.084.401h-4.51c-.849 0-1.562-.638-1.656-1.483l-.49-4.411c-.1-.895.53-1.707 1.42-1.834l4.185-.605Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
))
